/* components/patterns/States.jsx — единые состояния: Skeleton, EmptyState,
   ErrorState, ForbiddenState, LoadingState. Каждый экран обязан их иметь. */

import { Button } from '../ui/Button.jsx';
import { Icon } from '../ui/Icon.jsx';

  function LoadingState({ label = 'Загрузка…' }) {
    return (
      <div className="state state--loading">
        <Icon name="spinner" size={28} />
        <div className="t-body text-dim">{label}</div>
      </div>
    );
  }

  function EmptyState({ icon = 'grid', title, body, action, serif = true }) {
    return (
      <div className="state state--empty">
        <div className="state__glyph"><Icon name={icon} size={26} /></div>
        <h3 className={serif ? 't-display state__title-serif' : 't-h3'}>{title}</h3>
        {body && <p className="state__body t-body text-dim">{body}</p>}
        {action && <div className="state__action">{action}</div>}
      </div>
    );
  }

  function ErrorState({ title = 'Что-то пошло не так', body = 'Не удалось загрузить данные. Попробуйте ещё раз.', onRetry }) {
    return (
      <div className="state state--error">
        <div className="state__glyph state__glyph--bad"><Icon name="alert-triangle" size={26} /></div>
        <h3 className="t-h3">{title}</h3>
        <p className="state__body t-body text-dim">{body}</p>
        {onRetry && <Button variant="secondary" iconLeft="refresh" onClick={onRetry}>Повторить</Button>}
      </div>
    );
  }

  function ForbiddenState({ title = 'Нет доступа', body = 'У вас нет прав для просмотра этого раздела. Обратитесь к администратору пространства.' }) {
    return (
      <div className="state state--forbidden">
        <div className="state__glyph state__glyph--warn"><Icon name="alert-circle" size={26} /></div>
        <h3 className="t-h3">{title}</h3>
        <p className="state__body t-body text-dim">{body}</p>
      </div>
    );
  }

  // диспетчер по {loading,error}: оборачивает контент экрана
  function QueryBoundary({ loading, error, empty, onRetry, children,
                          loadingEl, emptyEl, skeleton, forbiddenBody, forbiddenTitle }) {
    if (loading) return skeleton || loadingEl || <LoadingState />;
    if (error && error.status === 403) {
      // контекстная 403-копия: явный пропс forbiddenBody либо err.detail из API
      const body = forbiddenBody || (error && (error.detail || error.message)) || undefined;
      return <ForbiddenState title={forbiddenTitle} body={body} />;
    }
    if (error) return <ErrorState onRetry={onRetry} />;
    if (empty) return emptyEl || <EmptyState title="Пока пусто" />;
    return children;
  }

export { LoadingState };
export { EmptyState };
export { ErrorState };
export { ForbiddenState };
export { QueryBoundary };
